export default __webpack_public_path__ + "a0e555ef00128209d2ba481b4c54d653.svg";